import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogDetails: [],
  isLoading: false,
  error: null,
  isError: false,
  isInvalidSlug: false,
};

export const blogDetailsRedux = createSlice({
  name: "blogDetailsRedux",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },

    setBlogDetailsState: (state, action) => {
      const newState = {
        ...state,
      };
      if (action?.payload?.key) {
        newState[action.payload.key] = action.payload.value;
      }
      return newState;
    },

    getBlogDetailsRequest: (state) => {
      const newState = {
        ...state,
        isLoading: true,
        // blogDetails: [],
        isError: false,
        error: false,
        isInvalidSlug: false,
      };

      return newState;
    },

    getBlogDetailsSuccess: (state, action) => {
      const newState = {
        ...state,
        isInvalidSlug: !action.payload?.blogs?.length,
        isLoading: false,
        error: null,
        isError: false,
        blogDetails: action?.payload,
      };

      return newState;
    },

    getBlogDetailsFailure: (state, action) => {
      const newState = {
        ...state,
        isInvalidSlug: true,
        isLoading: false,
        isError: true,
        error: action.payload,
        blogDetails: [],
      };

      return newState;
    },
  },
});

export const {
  resetState,
  setBlogDetailsState,

  getBlogDetailsRequest,
  getBlogDetailsSuccess,
  getBlogDetailsFailure,
} = blogDetailsRedux.actions;

export default blogDetailsRedux.reducer;
